export default __webpack_public_path__ + "575a16032362734e589d1d2e6e2c1a77.svg";